export default "__VITE_ASSET__924cb771__"